import React from 'react';
import { Link } from 'react-router-dom';

import { Pagination } from 'swiper';

import { Swiper, SwiperSlide } from 'swiper/react';

import LockContent from '@common/react/components/UI/LockContent/LockContent';
import { useModal } from '@common/react/components/Modal/ModalContextProvider';

import { Case } from '@commonTuna/react/objects/BaseCase';
import CaseModalInner from '@commonTuna/react/components/UI/CaseModalInner/CaseModalInner';

import BeforeAfterItem from '@app/components/Pages/BeforeAfterList/BeforeAfterItem';
import { t, lockText } from '@app/components/Utils';

interface Props {
	cases: Array<Case>;
	pageId: number;
}

interface ModalState {
	visible: boolean;
	caseId: number | null;
	index: null | number;
}

const initialModalState: ModalState = {
	visible: false,
	caseId: null,
	index: null,
};

const Cases: React.FC<Props> = (props) => {
	const {
		cases,
		pageId,
	} = props;
	const { renderModal } = useModal();
	const [modalState, setModalState] = React.useState(initialModalState);

	const handleCaseClick = (caseId: number) => {
		setModalState((prevState) => ({
			...prevState,
			visible: true,
			caseId,
		}));
	};

	const closeDialog = () => {
		setModalState((prevState) => ({
			...prevState,
			visible: false,
			index: null,
		}));
	};

	return <>
		{cases.length > 0 && <div className="service-page__cases service-page__block text-center is-relative">
			<LockContent
				title="WARNING:"
				subTitle={lockText}
			/>
			<div className="extra-text-block" id="cases" style={{ margin: 0 }}>
				<h2>
					Before and after
				</h2>
			</div>
			<div className="cases-wrapper">
				<Swiper
					pagination={{
						clickable: true,
					}}
					modules={[Pagination]}
					className="mySwiper"
					autoHeight
					observer
					observeParents
					observeSlideChildren
					breakpoints={{
						480: {
							slidesPerView: 1,
							spaceBetween: 30,
						},
						500: {
							slidesPerView: 2,
							spaceBetween: 40,
						},
						950: {
							slidesPerView: 3,
							spaceBetween: 40,
						},
					}}
				>
					{cases.map((item) => <SwiperSlide key={`${item.id}`}>
						<BeforeAfterItem
							item={item}
							onCaseClick={handleCaseClick}
						/>
					</SwiperSlide>)}
				</Swiper>
			</div>
			<Link to={`/gallery?pageIds=[${pageId}]`} className="article__link">Find More</Link>
		</div>}
		{renderModal(modalState.visible, closeDialog, {
			afterClose: closeDialog,
			className: 'dark-modal case-modal',
			style: { width: '100%' },
			children: <CaseModalInner
				lang="En"
				t={t}
				caseId={modalState.caseId}
			/>,
		})}
	</>;
};

export default Cases;
